// import React, { useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// // Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react";
// import { motion } from "framer-motion";
// // Import Swiper styles
// import "swiper/css";
// import "swiper/css/navigation";

// import { Navigation } from "swiper/modules";
// import styled, { keyframes } from "styled-components";
// import {
//   Code,
//   Users,
//   Award,
//   Mail,
//   Phone,
//   MapPin,
//   Star,
//   CheckCircle,
//   ArrowRight,
//   Globe,
//   Smartphone,
//   Server,
//   Database,
//   Shield,
//   Send,
//   Clock,
//   Target,
// } from "lucide-react";
// import { BackgroundElementServices } from "./GlobalStyle";
// import { pulse, fadeInUp } from "./GlobalStyle";
// import CompaniesSection from "./CompaniesSection";

// export const Container = styled.div`
//   max-width: 1400px;
//   margin: 0 auto;
//   padding: 0 2rem;

//   @media (max-width: 768px) {
//     padding: 0 1rem;
//   }
// `;

// export const Section = styled.section`
//   padding: 6rem 0;
//   position: relative;

//   @media (max-width: 768px) {
//     padding: 4rem 0;
//   }
// `;

// const SubServiceTitle = styled.div`
//   width: 40%;
//   margin: 8rem auto 0.3rem auto;
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   gap: 0.4rem;

//   p {
//     font-size: 2rem;
//     // font-family: "Grechen Fuemen", "cursive";
//     text-transform: uppercase;
//     margin: 0.3rem 0; /* espace haut/bas réduit */
//     padding: 0.2rem 0; /* léger espace intérieur optionnel */

//     // width: 45%;
//     text-align: center;
//   }

//   @media (min-width: 375px) and (max-width: 480px) {
//     width: 55%;
//   }
// `;

// const Line = styled.div`
//   width: 100%;
//   height: 2px;
//   background-color: #fafafa;
//   transform-origin: center; /* animation depuis le centre */
// `;

// export const HeroSection = styled(Section)`
//   // min-height: 100vh;
//   display: flex;
//   align-items: center;
//   text-align: center;
//   // padding-top: 2rem;
// `;

// export const HeroContent = styled.div`
//   animation: ${fadeInUp} 1s ease-out;
// `;

// export const Badge = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.5rem;
//   background: rgba(255, 71, 87, 0.1);
//   border: 1px solid rgba(255, 71, 87, 0.3);
//   color: #ff4757;
//   padding: 0.75rem 1.5rem;
//   border-radius: 50px;
//   font-size: 0.9rem;
//   font-weight: 500;
//   margin-bottom: 2rem;
//   animation: ${pulse} 3s ease-in-out infinite;
// `;

// export const HeroTitle = styled.h2`
//   background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   background-clip: text;

//   //font-size: 1.6rem;
//   text-transform: uppercase;

//   @media (max-width: 1024px) {
//     // font-size: 3rem;
//   }

//   @media (max-width: 768px) {
//     // font-size: 2.5rem;
//   }
// `;

// export const HeroDescription = styled.p`
//   max-width: 70%;
//   margin: 0 auto 3rem;
//   line-height: 1.7;

//   @media (max-width: 768px) {
//     // font-size: 1.1rem;
//     margin-bottom: 2rem;
//   }
// `;

// export const StatsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(3, 1fr);
//   gap: 2rem;
//   max-width: 800px;
//   margin: 0 auto;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 1.5rem;
//   }
// `;

// export const StatCard = styled.div`
//   background: rgba(255, 255, 255, 0.05);
//   backdrop-filter: blur(20px);
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   border-radius: 20px;
//   padding: 2rem;
//   text-align: center;
//   transition: all 0.3s ease;
//   animation: ${fadeInUp} 1s ease-out;
//   animation-delay: ${(props) => props.delay || "0s"};

//   &:hover {
//     transform: translateY(-5px);
//     background: rgba(255, 255, 255, 0.08);
//     border-color: rgba(255, 71, 87, 0.3);
//   }

//   .icon {
//     margin-bottom: 1rem;
//     color: rgba(180, 1, 18, 1);
//   }

//   h3 {
//     font-size: 1.3rem;
//     font-weight: 700;
//     margin-bottom: 0.5rem;
//     background: linear-gradient(
//       to right,
//       #544eba 0%,
//       #c21412 60%,
//       #e3b403 100%
//     );
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//   }

//   p {
//     color: #aaa;
//     font-size: 0.9rem;
//   }
// `;

// // Services Section
// export const ServicesSection = styled(Section)`
//   background: rgba(255, 255, 255, 0.02);
// `;

// export const SectionTitle = styled.h2`
//   text-transform: uppercase;
//   text-align: center;
//   margin-bottom: 1rem;
//   background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   background-clip: text;

//   @media (max-width: 768px) {
//     // font-size: 2.5rem;
//   }
// `;

// export const SectionSubtitle = styled.p`
//   text-align: center;
//   max-width: 50%;
//   margin: 0 auto 2rem;
//   line-height: 1.6;

//   @media (max-width: 768px) {
//     font-size: 1.1rem;
//     margin-bottom: 3rem;
//   }
// `;

// export const ServicesGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
//   gap: 2rem;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//     gap: 1.5rem;
//   }

//   @media (max-width: 480px) {
//     grid-template-columns: 1fr;
//   }
// `;

// export const ServiceCard = styled.div`
//   background: rgba(255, 255, 255, 0.05);
//   backdrop-filter: blur(20px);
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   border-radius: 24px;
//   padding: 2.5rem;
//   transition: all 0.4s ease;
//   position: relative;
//   overflow: hidden;
//   animation: ${fadeInUp} 0.8s ease-out;
//   animation-delay: ${(props) => props.delay || "0s"};

//   &::before {
//     content: "";
//     position: absolute;
//     top: 0;
//     left: 0;
//     right: 0;
//     height: 4px;
//     background: ${(props) =>
//       props.gradient || "linear-gradient(135deg, #c21412, #544eba)"};
//     transform: scaleX(0);
//     transition: transform 0.3s ease;
//   }

//   &:hover {
//     transform: translateY(-10px);
//     background: rgba(255, 255, 255, 0.08);
//     border-color: rgba(255, 71, 87, 0.3);
//     box-shadow: 0 20px 60px rgba(255, 71, 87, 0.1);

//     &::before {
//       transform: scaleX(1);
//     }

//     .service-icon {
//       transform: scale(1.1) rotate(5deg);
//     }
//   }

//   .service-icon {
//     width: 60px;
//     height: 60px;
//     background: ${(props) =>
//       props.gradient ||
//       "linear-gradient(to right, #c21412, rgba(92, 0, 39, 1)"};
//     border-radius: 16px;
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     margin-bottom: 1.5rem;
//     transition: all 0.3s ease;
//   }

//   .description {
//     color: #ccc;
//     margin-bottom: 1.5rem;
//     line-height: 1.6;
//   }

//   .details-list {
//     list-style: none;
//     margin-bottom: 1.5rem;

//     li {
//       display: flex;
//       align-items: flex-start;
//       gap: 0.75rem;
//       margin-bottom: 0.75rem;
//       color: #aaa;
//       font-size: 0.9rem;

//       .check-icon {
//         color: #c21412;
//         margin-top: 0.1rem;
//         flex-shrink: 0;
//       }
//     }
//   }

//   .learn-more {
//     display: inline-flex;
//     align-items: center;
//     gap: 0.5rem;
//     color: #c21412;
//     font-weight: 600;
//     text-decoration: none;
//     transition: all 0.3s ease;
//     border-top: 1px solid rgba(255, 255, 255, 0.1);
//     padding-top: 1.5rem;

//     &:hover {
//       gap: 1rem;
//       color: #544eba;
//     }

//     .arrow-icon {
//       transition: transform 0.3s ease;
//     }

//     &:hover .arrow-icon {
//       transform: translateX(5px);
//     }
//   }
// `;

// /* ---------- Offres (Audit / MVP / Coaching) ---------- */

// export const OffersSection = styled(Section)``;

// export const OfferMeta = styled.div`
//   display: flex;
//   align-items: center;
//   gap: 1.25rem;
//   flex-wrap: wrap;
//   margin-bottom: 1.25rem;

//   .meta-item {
//     display: inline-flex;
//     align-items: center;
//     gap: 0.4rem;
//     color: #aaa;
//     font-size: 0.85rem;

//     svg {
//       color: #c21412;
//       flex-shrink: 0;
//     }
//   }
// `;

// export const OfferPrice = styled.div`
//   font-size: 1.8rem;
//   font-weight: 700;
//   margin-bottom: 0.25rem;
//   background: linear-gradient(to right, #544eba 0%, #c21412 60%, #e3b403 100%);
//   -webkit-background-clip: text;
//   -webkit-text-fill-color: transparent;
//   background-clip: text;

//   span {
//     font-size: 0.95rem;
//     font-weight: 500;
//     color: #aaa;
//     -webkit-text-fill-color: #aaa;
//     margin-left: 0.4rem;
//   }
// `;

// export const OfferGoalBadge = styled.div`
//   display: inline-block;
//   padding: 0.3rem 0.9rem;
//   border-radius: 50px;
//   font-size: 0.75rem;
//   font-weight: 600;
//   text-transform: uppercase;
//   letter-spacing: 0.03em;
//   background: rgba(255, 71, 87, 0.1);
//   border: 1px solid rgba(255, 71, 87, 0.3);
//   color: #ff4757;
//   margin-bottom: 1.25rem;
// `;

// export const OfferNote = styled.p`
//   font-size: 0.85rem;
//   color: #999;
//   font-style: italic;
//   margin: -0.5rem 0 1.5rem 0;
//   padding-top: 0.75rem;
//   border-top: 1px dashed rgba(255, 255, 255, 0.1);
// `;

// export const OfferCtas = styled.div`
//   display: flex;
//   flex-direction: column;
//   gap: 0.75rem;
//   border-top: 1px solid rgba(255, 255, 255, 0.1);
//   padding-top: 1.5rem;

//   .calendly-btn {
//     display: inline-flex;
//     align-items: center;
//     justify-content: center;
//     gap: 0.5rem;
//     padding: 0.85rem 1.5rem;
//     border-radius: 12px;
//     background: ${(props) =>
//       props.gradient || "linear-gradient(135deg, #c21412, #544eba)"};
//     color: #fff;
//     font-weight: 600;
//     text-decoration: none;
//     transition: all 0.3s ease;
//     text-align: center;

//     &:hover {
//       transform: translateY(-2px);
//       filter: brightness(1.1);
//     }
//   }

//   .secondary-link {
//     text-align: center;
//     color: #999;
//     font-size: 0.85rem;
//     text-decoration: underline;
//     text-underline-offset: 3px;
//     transition: color 0.3s ease;

//     &:hover {
//       color: #fff;
//     }
//   }
// `;

// // Testimonials Section
// export const TestimonialsSection = styled(Section)`
//   background: rgba(55, 66, 250, 0.05);
// `;

// export const TestimonialsGrid = styled.div`
//   display: grid;
//   grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
//   gap: 2rem;

//   @media (max-width: 768px) {
//     grid-template-columns: 1fr;
//   }

//   .mySwiper {
//     width: 100%;
//     padding: 2rem 0;
//   }
// `;

// export const TestimonialCard = styled.div`
//   background: rgba(255, 255, 255, 0.05);
//   backdrop-filter: blur(20px);
//   border: 1px solid rgba(255, 255, 255, 0.1);
//   border-radius: 20px;
//   padding: 2rem;
//   transition: all 0.3s ease;
//   animation: ${fadeInUp} 0.8s ease-out;
//   animation-delay: ${(props) => props.delay || "0s"};

//   &:hover {
//     transform: translateY(-5px);
//     background: rgba(255, 255, 255, 0.08);
//     border-color: rgba(55, 66, 250, 0.3);
//   }

//   .stars {
//     display: flex;
//     gap: 0.25rem;
//     margin-bottom: 1rem;

//     .star {
//       color: #ffd700;
//     }
//   }

//   .quote {
//     color: #ccc;
//     font-style: italic;
//     margin-bottom: 1.5rem;
//     line-height: 1.6;
//   }

//   .author {
//     .name {
//       font-weight: 600;
//       color: #fff;
//       margin-bottom: 0.25rem;
//     }

//     .title {
//       color: #aaa;
//       font-size: 0.9rem;
//     }
//   }
// `;

// // Contact Section
// export const ContactSection = styled(Section)`
//   background: linear-gradient(
//     135deg,
//     rgba(255, 71, 87, 0.08),
//     rgba(55, 66, 250, 0.08)
//   );
// `;

// export const ContactInfo = styled.div`
//   display: flex;
//   flex-direction: column;
//   align-items: center;
//   max-width: 640px;
//   margin: 0 auto;
//   text-align: center;

//   .title {
//     text-transform: uppercase;
//     margin-bottom: 1rem;
//     background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
//     -webkit-background-clip: text;
//     -webkit-text-fill-color: transparent;
//     background-clip: text;
//     font-size: 2rem;
//     line-height: 1.2;

//     @media (max-width: 768px) {
//       font-size: 1.6rem;
//     }

//     @media (max-width: 480px) {
//       font-size: 1.35rem;
//     }
//   }

//   .description {
//     color: #ccc;
//     margin-bottom: 2.5rem;
//     line-height: 1.7;
//     font-size: 1.05rem;
//     max-width: 520px;

//     @media (max-width: 480px) {
//       font-size: 0.95rem;
//     }
//   }
// `;

// export const ContactItem = styled.div`
//   display: inline-flex;
//   align-items: center;
//   gap: 0.9rem;
//   padding: 0.75rem 1.5rem 0.75rem 0.75rem;

//   background: rgba(255, 71, 87, 0.06);
//   border: 1px solid rgba(255, 71, 87, 0.25);
//   border-radius: 14px;

//   transition:
//     background 0.3s ease,
//     border-color 0.3s ease,
//     box-shadow 0.3s ease;

//   &:hover {
//     background: rgba(255, 71, 87, 0.12);
//     border-color: rgba(255, 71, 87, 0.5);
//     box-shadow: 0 4px 20px rgba(255, 71, 87, 0.12);
//   }

//   .icon-wrapper {
//     width: 42px;
//     height: 42px;
//     flex-shrink: 0;
//     background: rgba(255, 71, 87, 0.15);
//     border: 1px solid rgba(255, 71, 87, 0.3);
//     border-radius: 10px;
//     display: flex;
//     align-items: center;
//     justify-content: center;

//     .icon {
//       color: #ff4757;
//     }
//   }

//   .value {
//     color: #fff;
//     font-weight: 600;
//     font-size: 1rem;
//     text-decoration: none;
//     white-space: nowrap;

//     &:hover {
//       color: #ff4757;
//     }
//   }
// `;

// // ⚠️ Remplace ce placeholder par ton vrai lien Calendly
// const CALENDLY_LINK = "YOUR_CALENDLY_LINK";

// const TrainingServices = () => {
//   const { t } = useTranslation();

//   const services = [
//     {
//       icon: Shield,
//       title: t("services.accessibility.accessTitle"),
//       description: t("services.accessibility.accessDesc"),
//       details: [
//         t("services.accessibility.accessDetailsOne"),
//         t("services.accessibility.accessDetailsTwo"),
//         t("services.accessibility.accessDetailsThree"),
//         t("services.accessibility.accessDetailsFour"),
//         t("services.accessibility.accessDetailsFive"),
//       ],
//       gradient: "linear-gradient(135deg, #c21412, rgba(92, 0, 39, 1))",
//     },
//     {
//       icon: Smartphone,
//       title: t("services.native.natTitle"),
//       description: t("services.native.natDesc"),
//       details: [
//         t("services.native.natDetailsOne"),
//         t("services.native.natDetailsTwo"),
//         t("services.native.natDetailsThree"),
//         t("services.native.natDetailsFour"),
//         t("services.native.natDetailsFive"),
//       ],
//       gradient: "linear-gradient(135deg, #3742fa, rgba(2, 6, 66, 1))",
//     },
//     {
//       icon: Server,
//       title: t("services.node.nodeTitle"),
//       description: t("services.node.nodeDesc"),
//       details: [
//         t("services.node.nodeDetailsOne"),
//         t("services.node.nodeDetailsTwo"),
//         t("services.node.nodeDetailsThree"),
//         t("services.node.nodeDetailsFour"),
//         t("services.node.nodeDetailsFive"),
//         t("services.node.nodeDetailsSix"),
//       ],
//       gradient: "linear-gradient(135deg, #ef7943ff, #a83905ff)",
//     },
//     {
//       icon: Database,
//       title: t("services.data.dataTitle"),
//       description: t("services.data.dataDesc"),
//       details: [
//         t("services.data.dataDetailsOne"),
//         t("services.data.dataDetailsTwo"),
//         t("services.data.dataDetailsThree"),
//         t("services.data.dataDetailsFour"),
//         t("services.data.dataDetailsFive"),
//         t("services.data.dataDetailsSix"),
//       ],
//       gradient: "linear-gradient(135deg, #b539d7ff, #4c0560ff)",
//     },
//     {
//       icon: Database,
//       title: t("services.sql.sqlTitle"),
//       description: t("services.sql.sqlDesc"),
//       details: [
//         t("services.sql.sqlDetailsOne"),
//         t("services.sql.sqlDetailsTwo"),
//         t("services.sql.sqlDetailsThree"),
//         t("services.sql.sqlDetailsFour"),
//         t("services.sql.sqlDetailsFive"),
//         t("services.sql.sqlDetailsSix"),
//       ],
//       gradient: "linear-gradient(135deg, #fd88b1ff, #e63d8fff)",
//     },
//     {
//       icon: Globe,
//       title: t("services.archi.archiTitle"),
//       description: t("services.archi.archiDesc"),
//       details: [
//         t("services.archi.archiDetailsOne"),
//         t("services.archi.archiDetailsTwo"),
//         t("services.archi.archiDetailsThree"),
//         t("services.archi.archiDetailsFour"),
//         t("services.archi.archiDetailsFive"),
//         t("services.archi.archiDetailsSix"),
//       ],
//       gradient: "linear-gradient(135deg, #0aad8dff, #004544ff)",
//     },
//   ];

//   const offers = [
//     {
//       icon: Shield,
//       title: t("services.offers.audit.title"),
//       price: t("services.offers.audit.price"),
//       priceNote: t("services.offers.audit.priceNote"),
//       goal: t("services.offers.audit.goal"),
//       duration: t("services.offers.audit.duration"),
//       description: t("services.offers.audit.description"),
//       details: [
//         t("services.offers.audit.detailsOne"),
//         t("services.offers.audit.detailsTwo"),
//         t("services.offers.audit.detailsThree"),
//         t("services.offers.audit.detailsFour"),
//         t("services.offers.audit.detailsFive"),
//         t("services.offers.audit.detailsSix"),
//       ],
//       note: t("services.offers.audit.note"),
//       gradient: "linear-gradient(135deg, #c21412, rgba(92, 0, 39, 1))",
//     },
//     {
//       icon: Code,
//       title: t("services.offers.mvp.title"),
//       price: t("services.offers.mvp.price"),
//       priceNote: t("services.offers.mvp.priceNote"),
//       goal: t("services.offers.mvp.goal"),
//       duration: t("services.offers.mvp.duration"),
//       description: t("services.offers.mvp.description"),
//       details: [
//         t("services.offers.mvp.detailsOne"),
//         t("services.offers.mvp.detailsTwo"),
//         t("services.offers.mvp.detailsThree"),
//         t("services.offers.mvp.detailsFour"),
//         t("services.offers.mvp.detailsFive"),
//         t("services.offers.mvp.detailsSix"),
//       ],
//       note: t("services.offers.mvp.note"),
//       gradient: "linear-gradient(135deg, #3742fa, rgba(2, 6, 66, 1))",
//     },
//     {
//       icon: Users,
//       title: t("services.offers.coaching.title"),
//       price: t("services.offers.coaching.price"),
//       priceNote: t("services.offers.coaching.priceNote"),
//       goal: t("services.offers.coaching.goal"),
//       duration: t("services.offers.coaching.duration"),
//       description: t("services.offers.coaching.description"),
//       details: [
//         t("services.offers.coaching.detailsOne"),
//         t("services.offers.coaching.detailsTwo"),
//         t("services.offers.coaching.detailsThree"),
//         t("services.offers.coaching.detailsFour"),
//         t("services.offers.coaching.detailsFive"),
//       ],
//       note: t("services.offers.coaching.note"),
//       gradient: "linear-gradient(135deg, #e3b403, #c21412)",
//     },
//   ];

//   return (
//     <>
//       {/* <GlobalStyle /> */}

//       {/* Background Elements */}
//       <BackgroundElementServices className="red-1" />
//       <BackgroundElementServices className="blue-1" />
//       <BackgroundElementServices className="red-2" />
//       <BackgroundElementServices className="blue-2" />

//       {/* Hero Section */}

//       <SubServiceTitle>
//         <Line
//           as={motion.div}
//           initial={{ scaleX: 0 }}
//           whileInView={{ scaleX: 1 }}
//           transition={{ duration: 0.8, ease: "easeOut" }}
//         />

//         <p>{t("services.titleTraining")}</p>

//         <Line
//           as={motion.div}
//           initial={{ scaleX: 0 }}
//           whileInView={{ scaleX: 1 }}
//           transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//         />
//       </SubServiceTitle>

//       <HeroSection>
//         <Container>
//           <HeroContent>
//             <Badge>
//               <Award size={16} />
//               <span>{t("services.expTime")}</span>
//             </Badge>

//             <HeroTitle>{t("services.heroTitle")}</HeroTitle>

//             <HeroDescription>{t("services.heroDesc")}</HeroDescription>

//             <StatsGrid>
//               <StatCard delay="0.2s">
//                 <Users size={32} className="icon" />
//                 <h3>{t("services.statCard.userTitle")}</h3>
//                 <p>{t("services.statCard.userText")}</p>
//               </StatCard>
//               <StatCard delay="0.4s">
//                 <Star size={32} className="icon" />
//                 <h3>{t("services.statCard.starTitle")}</h3>
//                 <p>{t("services.statCard.starText")}</p>
//               </StatCard>
//               <StatCard delay="0.6s">
//                 <Globe size={32} className="icon" />
//                 <h3>{t("services.statCard.formatTitle")}</h3>
//                 <p>{t("services.statCard.formatText")}</p>
//               </StatCard>
//             </StatsGrid>
//           </HeroContent>
//         </Container>
//       </HeroSection>

//       {/* Services Section (Formation) */}
//       <ServicesSection>
//         <Container>
//           <SectionTitle>{t("services.expertiseTitle")}</SectionTitle>
//           <SectionSubtitle>{t("services.expertText")}</SectionSubtitle>

//           <ServicesGrid>
//             {services.map((service, index) => (
//               <ServiceCard
//                 key={index}
//                 delay={`${index * 0.1}s`}
//                 gradient={service.gradient}
//               >
//                 <div className="service-icon">
//                   <service.icon size={24} color="white" />
//                 </div>

//                 <h3>{service.title}</h3>
//                 <p className="description">{service.description}</p>

//                 <ul className="details-list">
//                   {service.details.map((detail, detailIndex) => (
//                     <li key={detailIndex}>
//                       <CheckCircle size={16} className="check-icon" />
//                       <span>{detail}</span>
//                     </li>
//                   ))}
//                 </ul>

//                 <a href="#contact" className="learn-more">
//                   <span>{t("services.quote")}</span>
//                   <ArrowRight size={16} className="arrow-icon" />
//                 </a>
//               </ServiceCard>
//             ))}
//           </ServicesGrid>
//         </Container>
//       </ServicesSection>

//       {/* Offers Section (Prestations packagées) */}
//       <OffersSection>
//         <Container>
//           <SectionTitle>{t("services.offers.sectionTitle")}</SectionTitle>
//           <SectionSubtitle>
//             {t("services.offers.sectionSubtitle")}
//           </SectionSubtitle>

//           <ServicesGrid>
//             {offers.map((offer, index) => (
//               <ServiceCard
//                 key={index}
//                 delay={`${index * 0.1}s`}
//                 gradient={offer.gradient}
//               >
//                 <div className="service-icon">
//                   <offer.icon size={24} color="white" />
//                 </div>

//                 <OfferGoalBadge>{offer.goal}</OfferGoalBadge>

//                 <h3>{offer.title}</h3>

//                 <OfferPrice>
//                   {offer.price}
//                   {offer.priceNote && <span>{offer.priceNote}</span>}
//                 </OfferPrice>

//                 <OfferMeta>
//                   <span className="meta-item">
//                     <Clock size={14} />
//                     {offer.duration}
//                   </span>
//                 </OfferMeta>

//                 <p className="description">{offer.description}</p>

//                 <ul className="details-list">
//                   {offer.details.map((detail, detailIndex) => (
//                     <li key={detailIndex}>
//                       <CheckCircle size={16} className="check-icon" />
//                       <span>{detail}</span>
//                     </li>
//                   ))}
//                 </ul>

//                 {offer.note && <OfferNote>{offer.note}</OfferNote>}

//                 <OfferCtas gradient={offer.gradient}>
//                   <a
//                     href={CALENDLY_LINK}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="calendly-btn"
//                   >
//                     <Send size={16} />
//                     {t("services.offers.bookCta")}
//                   </a>
//                   <a href="/contact" className="secondary-link">
//                     {t("services.offers.contactCta")}
//                   </a>
//                 </OfferCtas>
//               </ServiceCard>
//             ))}
//           </ServicesGrid>
//         </Container>
//       </OffersSection>

//       <CompaniesSection />

//       {/* Contact Section */}
//       <ContactSection id="contact">
//         <Container>
//           <ContactInfo>
//             <h2 className="title">{t("services.ready")}</h2>
//             <p className="description">{t("services.textReady")}</p>

//             <ContactItem>
//               <div className="icon-wrapper">
//                 <Mail size={20} className="icon" />
//               </div>
//               <a href="/contact" className="value">
//                 {t("contact.title")}
//               </a>
//             </ContactItem>
//           </ContactInfo>
//         </Container>
//       </ContactSection>
//     </>
//   );
// };

// export default TrainingServices;

import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
import { motion } from "framer-motion";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import { Navigation } from "swiper/modules";
import styled, { keyframes } from "styled-components";
import {
  Code,
  Users,
  Award,
  Mail,
  Phone,
  MapPin,
  Star,
  CheckCircle,
  ArrowRight,
  Globe,
  Smartphone,
  Server,
  Database,
  Shield,
  Send,
  Clock,
  Target,
  Cpu,
  Sparkles,
} from "lucide-react";
import { BackgroundElementServices } from "./GlobalStyle";
import { pulse, fadeInUp } from "./GlobalStyle";
import CompaniesSection from "./CompaniesSection";

const TrainingServices = () => {
  const { t } = useTranslation();

  // 7 piliers d'expertise (remplace les 6 cartes "formation" par le positionnement
  // Full Stack / Lead Dev défini dans le repositionnement)
  const services = [
    {
      icon: Code,
      title: t("services.frontend.frontTitle"),
      description: t("services.frontend.frontDesc"),
      details: [
        t("services.frontend.frontDetailsOne"),
        t("services.frontend.frontDetailsTwo"),
        t("services.frontend.frontDetailsThree"),
        t("services.frontend.frontDetailsFour"),
        t("services.frontend.frontDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #3742fa, rgba(2, 6, 66, 1))",
    },
    {
      icon: Server,
      title: t("services.backend.backTitle"),
      description: t("services.backend.backDesc"),
      details: [
        t("services.backend.backDetailsOne"),
        t("services.backend.backDetailsTwo"),
        t("services.backend.backDetailsThree"),
        t("services.backend.backDetailsFour"),
        t("services.backend.backDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #ef7943ff, #a83905ff)",
    },
    {
      icon: Database,
      title: t("services.archidata.archiTitle"),
      description: t("services.archidata.archiDesc"),
      details: [
        t("services.archidata.archiDetailsOne"),
        t("services.archidata.archiDetailsTwo"),
        t("services.archidata.archiDetailsThree"),
        t("services.archidata.archiDetailsFour"),
        t("services.archidata.archiDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #b539d7ff, #4c0560ff)",
    },
    {
      icon: Shield,
      title: t("services.uxaccess.uxTitle"),
      description: t("services.uxaccess.uxDesc"),
      details: [
        t("services.uxaccess.uxDetailsOne"),
        t("services.uxaccess.uxDetailsTwo"),
        t("services.uxaccess.uxDetailsThree"),
        t("services.uxaccess.uxDetailsFour"),
        t("services.uxaccess.uxDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #c21412, rgba(92, 0, 39, 1))",
    },
    {
      icon: Cpu,
      title: t("services.testsdevops.testsTitle"),
      description: t("services.testsdevops.testsDesc"),
      details: [
        t("services.testsdevops.testsDetailsOne"),
        t("services.testsdevops.testsDetailsTwo"),
        t("services.testsdevops.testsDetailsThree"),
        t("services.testsdevops.testsDetailsFour"),
        t("services.testsdevops.testsDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #0aad8dff, #004544ff)",
    },
    {
      icon: Sparkles,
      title: t("services.ia.iaTitle"),
      description: t("services.ia.iaDesc"),
      details: [
        t("services.ia.iaDetailsOne"),
        t("services.ia.iaDetailsTwo"),
        t("services.ia.iaDetailsThree"),
        t("services.ia.iaDetailsFour"),
        t("services.ia.iaDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #fd88b1ff, #e63d8fff)",
    },
    {
      icon: Users,
      title: t("services.leaddev.leadTitle"),
      description: t("services.leaddev.leadDesc"),
      details: [
        t("services.leaddev.leadDetailsOne"),
        t("services.leaddev.leadDetailsTwo"),
        t("services.leaddev.leadDetailsThree"),
        t("services.leaddev.leadDetailsFour"),
        t("services.leaddev.leadDetailsFive"),
      ],
      gradient: "linear-gradient(135deg, #e3b403, #c21412)",
    },
  ];

  const offers = [
    {
      icon: Shield,
      title: t("services.offers.audit.title"),
      price: t("services.offers.audit.price"),
      priceNote: t("services.offers.audit.priceNote"),
      goal: t("services.offers.audit.goal"),
      duration: t("services.offers.audit.duration"),
      description: t("services.offers.audit.description"),
      details: [
        t("services.offers.audit.detailsOne"),
        t("services.offers.audit.detailsTwo"),
        t("services.offers.audit.detailsThree"),
        t("services.offers.audit.detailsFour"),
        t("services.offers.audit.detailsFive"),
        t("services.offers.audit.detailsSix"),
      ],
      note: t("services.offers.audit.note"),
      gradient: "linear-gradient(135deg, #c21412, rgba(92, 0, 39, 1))",
      calLink: "https://cal.com/johane-omiscar/audit",
    },
    {
      icon: Code,
      title: t("services.offers.mvp.title"),
      price: t("services.offers.mvp.price"),
      priceNote: t("services.offers.mvp.priceNote"),
      goal: t("services.offers.mvp.goal"),
      duration: t("services.offers.mvp.duration"),
      description: t("services.offers.mvp.description"),
      details: [
        t("services.offers.mvp.detailsOne"),
        t("services.offers.mvp.detailsTwo"),
        t("services.offers.mvp.detailsThree"),
        t("services.offers.mvp.detailsFour"),
        t("services.offers.mvp.detailsFive"),
        t("services.offers.mvp.detailsSix"),
      ],
      note: t("services.offers.mvp.note"),
      gradient: "linear-gradient(135deg, #3742fa, rgba(2, 6, 66, 1))",
      calLink: "https://cal.com/johane-omiscar/echange-professionnel",
    },
    {
      icon: Users,
      title: t("services.offers.coaching.title"),
      price: t("services.offers.coaching.price"),
      priceNote: t("services.offers.coaching.priceNote"),
      goal: t("services.offers.coaching.goal"),
      duration: t("services.offers.coaching.duration"),
      description: t("services.offers.coaching.description"),
      details: [
        t("services.offers.coaching.detailsOne"),
        t("services.offers.coaching.detailsTwo"),
        t("services.offers.coaching.detailsThree"),
        t("services.offers.coaching.detailsFour"),
        t("services.offers.coaching.detailsFive"),
      ],
      note: t("services.offers.coaching.note"),
      gradient: "linear-gradient(135deg, #e3b403, #c21412)",
      calLink:
        "https://cal.com/johane-omiscar/formation-accompagnement-technique",
    },
  ];

  return (
    <>
      <BackgroundElementServices className="red-1" />
      <BackgroundElementServices className="blue-1" />
      <BackgroundElementServices className="red-2" />
      <BackgroundElementServices className="blue-2" />

      <SubServiceTitle>
        <Line
          as={motion.div}
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        />

        <p>{t("services.titleTraining")}</p>

        <Line
          as={motion.div}
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
        />
      </SubServiceTitle>

      <HeroSection>
        <Container>
          <HeroContent>
            <Badge>
              <Award size={16} />
              <span>{t("services.expTime")}</span>
            </Badge>

            <HeroTitle>{t("services.heroTitle")}</HeroTitle>

            <HeroDescription>{t("services.heroDesc")}</HeroDescription>

            <StatsGrid>
              <StatCard delay="0.2s">
                <Users size={32} className="icon" />
                <h3>{t("services.statCard.userTitle")}</h3>
                <p>{t("services.statCard.userText")}</p>
              </StatCard>
              <StatCard delay="0.4s">
                <Star size={32} className="icon" />
                <h3>{t("services.statCard.starTitle")}</h3>
                <p>{t("services.statCard.starText")}</p>
              </StatCard>
              <StatCard delay="0.6s">
                <Globe size={32} className="icon" />
                <h3>{t("services.statCard.formatTitle")}</h3>
                <p>{t("services.statCard.formatText")}</p>
              </StatCard>
            </StatsGrid>
          </HeroContent>
        </Container>
      </HeroSection>

      {/* Services Section (7 piliers d'expertise) */}
      <ServicesSection>
        <Container>
          <SectionTitle>{t("services.expertiseTitle")}</SectionTitle>
          <SectionSubtitle>{t("services.expertText")}</SectionSubtitle>

          <ServicesGrid>
            {services.map((service, index) => (
              <ServiceCard
                key={index}
                delay={`${index * 0.1}s`}
                gradient={service.gradient}
              >
                <div className="service-icon">
                  <service.icon size={24} color="white" />
                </div>

                <h3>{service.title}</h3>
                <p className="description">{service.description}</p>

                <ul className="details-list">
                  {service.details.map((detail, detailIndex) => (
                    <li key={detailIndex}>
                      <CheckCircle size={16} className="check-icon" />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>

                <a href="/contact" className="learn-more">
                  <span>{t("services.quote")}</span>
                  <ArrowRight size={16} className="arrow-icon" />
                </a>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </Container>
      </ServicesSection>

      {/* Offers Section (Prestations packagées) */}
      <OffersSection>
        <Container>
          <SectionTitle>{t("services.offers.sectionTitle")}</SectionTitle>
          <SectionSubtitle>
            {t("services.offers.sectionSubtitle")}
          </SectionSubtitle>

          <ServicesGrid>
            {offers.map((offer, index) => (
              <ServiceCard
                key={index}
                delay={`${index * 0.1}s`}
                gradient={offer.gradient}
              >
                <div className="service-icon">
                  <offer.icon size={24} color="white" />
                </div>

                <OfferGoalBadge>{offer.goal}</OfferGoalBadge>

                <h3>{offer.title}</h3>

                <OfferPrice>
                  {offer.price}
                  {offer.priceNote && <span>{offer.priceNote}</span>}
                </OfferPrice>

                <OfferMeta>
                  <span className="meta-item">
                    <Clock size={14} />
                    {offer.duration}
                  </span>
                </OfferMeta>

                <p className="description">{offer.description}</p>

                <ul className="details-list">
                  {offer.details.map((detail, detailIndex) => (
                    <li key={detailIndex}>
                      <CheckCircle size={16} className="check-icon" />
                      <span>{detail}</span>
                    </li>
                  ))}
                </ul>

                {offer.note && <OfferNote>{offer.note}</OfferNote>}

                <OfferCtas gradient={offer.gradient}>
                  <a
                    href={offer.calLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="calendly-btn"
                  >
                    <Send size={16} />
                    {t("services.offers.bookCta")}
                  </a>
                  <a href="/contact" className="secondary-link">
                    {t("services.offers.contactCta")}
                  </a>
                </OfferCtas>
              </ServiceCard>
            ))}
          </ServicesGrid>
        </Container>
      </OffersSection>

      <CompaniesSection />

      {/* Contact Section */}
      <ContactSection id="contact">
        <Container>
          <ContactInfo>
            <h2 className="title">{t("services.ready")}</h2>
            <p className="description">{t("services.textReady")}</p>

            <ContactItem>
              <div className="icon-wrapper">
                <Mail size={20} className="icon" />
              </div>
              <a href="/contact" className="value">
                {t("contact.title")}
              </a>
            </ContactItem>
          </ContactInfo>
        </Container>
      </ContactSection>
    </>
  );
};

export default TrainingServices;

export const Container = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;

  @media (max-width: 768px) {
    padding: 0 1rem;
  }
`;

export const Section = styled.section`
  padding: 6rem 0;
  position: relative;

  @media (max-width: 768px) {
    padding: 4rem 0;
  }
`;

const SubServiceTitle = styled.div`
  width: 40%;
  margin: 8rem auto 0.3rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.4rem;

  p {
    font-size: 2rem;
    text-transform: uppercase;
    margin: 0.3rem 0;
    padding: 0.2rem 0;
    text-align: center;
  }

  @media (min-width: 375px) and (max-width: 480px) {
    width: 55%;
  }
`;

const Line = styled.div`
  width: 100%;
  height: 2px;
  background-color: #fafafa;
  transform-origin: center;
`;

export const HeroSection = styled(Section)`
  display: flex;
  align-items: center;
  text-align: center;
`;

export const HeroContent = styled.div`
  animation: ${fadeInUp} 1s ease-out;
`;

export const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 71, 87, 0.1);
  border: 1px solid rgba(255, 71, 87, 0.3);
  color: #ff4757;
  padding: 0.75rem 1.5rem;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 500;
  margin-bottom: 2rem;
  animation: ${pulse} 3s ease-in-out infinite;
`;

export const HeroTitle = styled.h2`
  background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-transform: uppercase;
`;

export const HeroDescription = styled.p`
  max-width: 70%;
  margin: 0 auto 3rem;
  line-height: 1.7;

  @media (max-width: 768px) {
    margin-bottom: 2rem;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  max-width: 800px;
  margin: 0 auto;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`;

export const StatCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2rem;
  text-align: center;
  transition: all 0.3s ease;
  animation: ${fadeInUp} 1s ease-out;
  animation-delay: ${(props) => props.delay || "0s"};

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 71, 87, 0.3);
  }

  .icon {
    margin-bottom: 1rem;
    color: rgba(180, 1, 18, 1);
  }

  h3 {
    font-size: 1.3rem;
    font-weight: 700;
    margin-bottom: 0.5rem;
    background: linear-gradient(
      to right,
      #544eba 0%,
      #c21412 60%,
      #e3b403 100%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  p {
    color: #aaa;
    font-size: 0.9rem;
  }
`;

// Services Section
export const ServicesSection = styled(Section)`
  background: rgba(255, 255, 255, 0.02);
`;

export const SectionTitle = styled.h2`
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 1rem;
  background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const SectionSubtitle = styled.p`
  text-align: center;
  max-width: 50%;
  margin: 0 auto 2rem;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1.1rem;
    margin-bottom: 3rem;
  }
`;

export const ServicesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;

export const ServiceCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 24px;
  padding: 2.5rem;
  transition: all 0.4s ease;
  position: relative;
  overflow: hidden;
  animation: ${fadeInUp} 0.8s ease-out;
  animation-delay: ${(props) => props.delay || "0s"};

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${(props) =>
      props.gradient || "linear-gradient(135deg, #c21412, #544eba)"};
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover {
    transform: translateY(-10px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 71, 87, 0.3);
    box-shadow: 0 20px 60px rgba(255, 71, 87, 0.1);

    &::before {
      transform: scaleX(1);
    }

    .service-icon {
      transform: scale(1.1) rotate(5deg);
    }
  }

  .service-icon {
    width: 60px;
    height: 60px;
    background: ${(props) =>
      props.gradient ||
      "linear-gradient(to right, #c21412, rgba(92, 0, 39, 1)"};
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    transition: all 0.3s ease;
  }

  .description {
    color: #ccc;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .details-list {
    list-style: none;
    margin-bottom: 1.5rem;

    li {
      display: flex;
      align-items: flex-start;
      gap: 0.75rem;
      margin-bottom: 0.75rem;
      color: #aaa;
      font-size: 0.9rem;

      .check-icon {
        color: #c21412;
        margin-top: 0.1rem;
        flex-shrink: 0;
      }
    }
  }

  .learn-more {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    color: #c21412;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
    padding-top: 1.5rem;

    &:hover {
      gap: 1rem;
      color: #544eba;
    }

    .arrow-icon {
      transition: transform 0.3s ease;
    }

    &:hover .arrow-icon {
      transform: translateX(5px);
    }
  }
`;

/* ---------- Offres (Audit / MVP / Coaching) ---------- */

export const OffersSection = styled(Section)``;

export const OfferMeta = styled.div`
  display: flex;
  align-items: center;
  gap: 1.25rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;

  .meta-item {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    color: #aaa;
    font-size: 0.85rem;

    svg {
      color: #c21412;
      flex-shrink: 0;
    }
  }
`;

export const OfferPrice = styled.div`
  font-size: 1.8rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  background: linear-gradient(to right, #544eba 0%, #c21412 60%, #e3b403 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;

  span {
    font-size: 0.95rem;
    font-weight: 500;
    color: #aaa;
    -webkit-text-fill-color: #aaa;
    margin-left: 0.4rem;
  }
`;

export const OfferGoalBadge = styled.div`
  display: inline-block;
  padding: 0.3rem 0.9rem;
  border-radius: 50px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03em;
  background: rgba(255, 71, 87, 0.1);
  border: 1px solid rgba(255, 71, 87, 0.3);
  color: #ff4757;
  margin-bottom: 1.25rem;
`;

export const OfferNote = styled.p`
  font-size: 0.85rem;
  color: #999;
  font-style: italic;
  margin: -0.5rem 0 1.5rem 0;
  padding-top: 0.75rem;
  border-top: 1px dashed rgba(255, 255, 255, 0.1);
`;

export const OfferCtas = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 1.5rem;

  .calendly-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    padding: 0.85rem 1.5rem;
    border-radius: 12px;
    background: ${(props) =>
      props.gradient || "linear-gradient(135deg, #c21412, #544eba)"};
    color: #fff;
    font-weight: 600;
    text-decoration: none;
    transition: all 0.3s ease;
    text-align: center;

    &:hover {
      transform: translateY(-2px);
      filter: brightness(1.1);
    }
  }

  .secondary-link {
    text-align: center;
    color: #999;
    font-size: 0.85rem;
    text-decoration: underline;
    text-underline-offset: 3px;
    transition: color 0.3s ease;

    &:hover {
      color: #fff;
    }
  }
`;

// Testimonials Section
export const TestimonialsSection = styled(Section)`
  background: rgba(55, 66, 250, 0.05);
`;

export const TestimonialsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }

  .mySwiper {
    width: 100%;
    padding: 2rem 0;
  }
`;

export const TestimonialCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 2rem;
  transition: all 0.3s ease;
  animation: ${fadeInUp} 0.8s ease-out;
  animation-delay: ${(props) => props.delay || "0s"};

  &:hover {
    transform: translateY(-5px);
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(55, 66, 250, 0.3);
  }

  .stars {
    display: flex;
    gap: 0.25rem;
    margin-bottom: 1rem;

    .star {
      color: #ffd700;
    }
  }

  .quote {
    color: #ccc;
    font-style: italic;
    margin-bottom: 1.5rem;
    line-height: 1.6;
  }

  .author {
    .name {
      font-weight: 600;
      color: #fff;
      margin-bottom: 0.25rem;
    }

    .title {
      color: #aaa;
      font-size: 0.9rem;
    }
  }
`;

// Contact Section
export const ContactSection = styled(Section)`
  background: linear-gradient(
    135deg,
    rgba(255, 71, 87, 0.08),
    rgba(55, 66, 250, 0.08)
  );
`;

export const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 640px;
  margin: 0 auto;
  text-align: center;

  .title {
    text-transform: uppercase;
    margin-bottom: 1rem;
    background: linear-gradient(to right, #ffffff, rgba(180, 1, 18, 1));
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    font-size: 2rem;
    line-height: 1.2;

    @media (max-width: 768px) {
      font-size: 1.6rem;
    }

    @media (max-width: 480px) {
      font-size: 1.35rem;
    }
  }

  .description {
    color: #ccc;
    margin-bottom: 2.5rem;
    line-height: 1.7;
    font-size: 1.05rem;
    max-width: 520px;

    @media (max-width: 480px) {
      font-size: 0.95rem;
    }
  }
`;

export const ContactItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.9rem;
  padding: 0.75rem 1.5rem 0.75rem 0.75rem;

  background: rgba(255, 71, 87, 0.06);
  border: 1px solid rgba(255, 71, 87, 0.25);
  border-radius: 14px;

  transition:
    background 0.3s ease,
    border-color 0.3s ease,
    box-shadow 0.3s ease;

  &:hover {
    background: rgba(255, 71, 87, 0.12);
    border-color: rgba(255, 71, 87, 0.5);
    box-shadow: 0 4px 20px rgba(255, 71, 87, 0.12);
  }

  .icon-wrapper {
    width: 42px;
    height: 42px;
    flex-shrink: 0;
    background: rgba(255, 71, 87, 0.15);
    border: 1px solid rgba(255, 71, 87, 0.3);
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;

    .icon {
      color: #ff4757;
    }
  }

  .value {
    color: #fff;
    font-weight: 600;
    font-size: 1rem;
    text-decoration: none;
    white-space: nowrap;

    &:hover {
      color: #ff4757;
    }
  }
`;
